export const fi = {
  nav: {
    start: "Etusivu",
    losningar: "Ratkaisut",
    produkter: "Palvelut",
    kundcase: "Asiakastapaukset",
    kunskap: "Tieto",
    information: "Tiedot",
    nyheter: "Uutiset",
    villkor: "Ehdot",
    developer: "Developer",
    omGeposit: "Tietoa Gepositista",
    kontakt: "Yhteystiedot",
    bokademo: "Varaa demo",
    loggain: "Kirjaudu",
    bestall: "Tilaa",
  },
  hero: {
    title: "Maantieteellinen hallinta liiketoimintaasi",
    subtitle:
      "Validoi osoitteet, hallitse maantieteellisiä alueita ja laadunvarmista osoiterekisterinne Ruotsissa, Norjassa, Tanskassa ja Suomessa – kaikki yhdellä alustalla. Älykkäämpiä päätöksiä ja vähemmän virheitä joka vaiheessa.",
    cta: "Varaa demo",
    ctaSecondary: "Katso ratkaisumme",
  },
  segments: {
    title: "Ketä autamme",
    subtitle:
      "Geposit tukee yrityksiä Ruotsissa, Norjassa, Tanskassa ja Suomessa tehostamaan maantieteellistä suunnittelua ja toimituslogistiikkaa.",
    transport: {
      title: "Kuljetus & Logistiikka",
      description:
        "Määritä toimitusalueet postinumerotarkkuudella, varmista oikeat osoitetiedot ja vähennä palautuksia. Täysi hallinta kuljetusmaantieteeseenne.",
    },
    service: {
      title: "Huolto & Asennus",
      description:
        "Suunnittele huoltoalueet, jaa resursseja maantieteellisesti ja anna asiakkaillenne tarkat käyntiajat. Vältä päällekkäiset vyöhykkeet.",
    },
    ecommerce: {
      title: "Verkkokauppa & Omni",
      description:
        "Määritä toimitusvyöhykkeet, validoi asiakasosoitteet reaaliajassa ja optimoi viimeisen mailin logistiikkanne. Vähemmän virheitä, tyytyväisempiä asiakkaita.",
    },
  },
  problems: {
    title: "Tunnistatko tämän?",
    subtitle: "Monet yritykset kamppailevat samojen maantieteellisten haasteiden kanssa päivittäin.",
    items: {
      areas: {
        title: "Epäselvät alueet",
        description:
          "Maantieteelliset vastuualueet perustuvat tuntumaan datan sijaan. Kukaan ei oikeastaan tiedä, missä rajat kulkevat.",
      },
      addresses: {
        title: "Virheelliset osoitetiedot",
        description:
          "Paketit palautuvat, huoltoteknikot eivät löydä oikeaan paikkaan ja asiakkaat turhautuvat viivästyksiin.",
      },
      manual: {
        title: "Manuaalinen suunnittelu",
        description:
          "Excel-taulukot, kartat seinällä ja tuntikausien manuaalinen työ maantieteellisten alueiden jakamiseksi ja päivittämiseksi.",
      },
      overview: {
        title: "Kokonaiskuvan puute",
        description:
          "Kukaan ei oikeastaan tiedä, miltä maantieteelliset alueet näyttävät tai ovatko ne optimaalisesti jaettu kattamaan kaikki tarpeet.",
      },
    },
  },
  solutions: {
    title: "Näin Geposit ratkaisee sen",
    subtitle:
      "Kolme pilaria, jotka antavat sinulle täyden hallinnan maantieteeseen ja osoitelaatuun koko Pohjolassa.",
    pillars: {
      areas: {
        title: "Omat alueet postinumerotarkkuudella",
        description:
          "Luo, visualisoi ja hallitse ainutlaatuisia maantieteellisiä alueita postinumeroalueilla rakennuspalikoina. Päivitä reaaliajassa tarpeiden muuttuessa.",
      },
      data: {
        title: "Oikeat osoite- ja postinumerotiedot",
        description:
          "Aina ajantasaiset, validoidut tiedot, jotka varmistavat jokaisen osoitteen oikeellisuuden. Vähennä palautuksia ja virhekustannuksia dramaattisesti.",
      },
      control: {
        title: "Visuaalinen yleiskuva & hallinta",
        description:
          "Näe koko maantieteenne kartalla. Analysoi, optimoi ja tee päätöksiä datan perusteella – ei tuntuman.",
      },
    },
  },
  products: {
    title: "Palvelumme",
    subtitle:
      "Kolme tehokasta työkalua, jotka antavat sinulle hallinnan maantieteeseen ja osoitetietoihin – täydellä kattavuudella koko Pohjolassa.",
    atlas: {
      title: "Atlas",
      description:
        "Luo ja hallitse omia maantieteellisiä alueita Ruotsissa, Norjassa, Tanskassa ja Suomessa. Visualisoi, analysoi ja optimoi maantieteellisiä rakenteitanne interaktiivisella kartalla.",
      cta: "Lue lisää Atlasista",
    },
    valid: {
      title: "Valid",
      description:
        "Validoi ja rikasta osoitteita reaaliajassa kaikissa Pohjoismaissa. Varmista, että jokainen osoite on oikein ennen kuin se saavuttaa järjestelmänne – API:n tai verkkokäyttöliittymän hakupalvelun kautta.",
      cta: "Lue lisää Validista",
    },
    adresstwatt: {
      title: "Osoitepesu",
      description:
        "Pese ja laadunvarmista olemassa olevat osoiterekisterinne koko Pohjolassa. Etsi ja korjaa virheet massana parantaaksenne datalaatua.",
      cta: "Lue lisää Osoitepesusta",
    },
  },
  productPages: {
    backToProducts: "Kaikki palvelut",
    features: "Ominaisuudet",
    benefits: "Edut",
    howItWorks: "Näin se toimii",
    ctaTitle: "Valmis aloittamaan?",
    ctaSubtitle: "Varaa demo ja katso, miten se toimii juuri teidän liiketoiminnassanne.",
    ctaButton: "Varaa demo",
    ctaSecondary: "Ota yhteyttä",
    atlas: {
      hero: {
        title: "Atlas",
        tagline: "Maantieteellinen aluehallinta",
        subtitle:
          "Luo, visualisoi ja hallitse omia maantieteellisiä alueita interaktiivisella kartalla. Määritä myyntialueet, toimitusvyöhykkeet ja huoltoalueet postinumerotarkkuudella – Ruotsissa, Norjassa, Tanskassa ja Suomessa.",
      },
      overview:
        "Atlas on Gepositin karttapalvelu omien maantieteellisten alueiden luomiseen ja hallintaan koko Pohjolassa. Rakenna alueenne postinumeroalueilla rakennuspalikoina, piirrä vapaasti tai tuo olemassa olevia rakenteita. Visualisoi dataa lämpökartoilla, mittaa etäisyyksiä ja jaa karttoja koko organisaatiollenne – iFramen tai API:n kautta. Atlas tukee Ruotsia, Norjaa, Tanskaa ja Suomea.",
      featureGroups: {
        createAndVisualize: "Luo & visualisoi postinumeroilla",
        calculateAndAnalyze: "Mittaa & analysoi",
        integrateAndShare: "Integroi & jaa",
      },
      features: {
        title: "Kaikki mitä tarvitset maantieteelliseen suunnitteluun",
        subtitle:
          "Atlas antaa teille työkalut maantieteellisten rakenteidenne hallintaan – yksinkertaisesti, visuaalisesti ja datavetoisesti.",
        items: {
          points: {
            title: "Pisteet kartalla",
            description:
              "Sijoita pisteitä osoitteella tai koordinaatilla. Visualisoi asiakasdataa, varastoja tai huoltopisteitä – yksittäin tai lämpökarttana.",
          },
          areas: {
            title: "Omat alueet postinumeroilla",
            description:
              "Rakenna alueita postinumeroalueilla rakennuspalikoina – jokainen postinumero napsahtaa paikoilleen palapelin palana. Piirrä vapaasti, tuo shapetiedostoja tai yhdistä menetelmiä täyden joustavuuden saavuttamiseksi.",
          },
          heatmaps: {
            title: "Lämpökartat",
            description:
              "Visualisoi datakuvioita maantieteellisesti lämpökartoilla. Näe asiakas-, toimitus- tai huoltotarpeiden keskittymät suoraan kartalla.",
          },
          routes: {
            title: "Etäisyyslaskenta",
            description:
              "Laske etäisyyksiä ja matka-aikoja pisteiden välillä. Valitse ajoneuvotyyppi realistisiin arvioihin – tuki huoltoalueiden ja vaikutusalueiden suunnitteluun.",
          },
          measure: {
            title: "Mittaustyökalut",
            description:
              "Käytä kantamaympyröitä etäisyyksien mittaamiseen pisteestä. Täydellinen vaikutusalueiden tai huoltosäteen määrittelyyn.",
          },
          attributes: {
            title: "Attribuutit & metadata",
            description:
              "Liitä omaa dataa alueisiin ja pisteisiin. Lisää hintavyöhykkeitä, vastuumyyjiä, kapasiteettia tai muita liiketoimintasääntöjä.",
          },
          iframe: {
            title: "iFrame-jakaminen",
            description:
              "Upota karttanne suoraan verkkosivulle tai sisäiseen järjestelmään. Anna kollegoille ja kumppaneille pääsy ilman kirjautumista.",
          },
          api: {
            title: "API-integraatio",
            description:
              "Hae ja lähetä dataa ohjelmallisesti REST API:n kautta. Integroi Atlas CRM-, ERP-, kuljetus- tai BI-alustaanne.",
          },
        },
      },
      useCases: {
        title: "Käyttökohteet",
        items: {
          salesDistricts: {
            title: "Myyntialueet",
            description:
              "Määritä ja visualisoi myyjien vastuualueet. Katso kattavuus, tunnista aukot ja tasapainota työkuormaa.",
          },
          deliveryZones: {
            title: "Toimitusvyöhykkeet",
            description:
              "Luo selkeät toimitusalueet terminaalin, kuljettajan tai alueen mukaan. Kaikki näkevät saman kuvan.",
          },
          priceZones: {
            title: "Hintavyöhykkeet",
            description:
              "Määritä maantieteelliset vyöhykkeet eri hinnoittelulla. Yhdistä liiketoimintajärjestelmäänne automaattista hinnanlaskentaa varten.",
          },
          biConnection: {
            title: "BI & analyysi",
            description:
              "Vie geodataa BI-työkaluunne tai yhdistä suoraan API:n kautta. Maantieteellinen ulottuvuus raportteihinnne.",
          },
          distanceCalc: {
            title: "Etäisyyslaskenta",
            description:
              "Laske etäisyyksiä ja matka-aikoja pisteiden välillä eri ajoneuvotyypeillä. Tuki suunnitteluun ja aikataulutukseen.",
          },
          crmConnection: {
            title: "CRM-yhteys",
            description:
              "Synkronoi maantieteelliset alueet CRM-järjestelmäänne. Automaattinen asiakkaiden kohdistus oikealle myyjälle.",
          },
        },
      },
      benefits: {
        title: "Miksi Atlas?",
        items: {
          time: {
            title: "Säästä aikaa",
            description:
              "Lopeta manuaaliset Excel-taulukot ja paperikartat. Tee minuuteissa se, mikä aiemmin vei tunteja.",
          },
          decisions: {
            title: "Paremmat päätökset",
            description:
              "Perusta maantieteelliset päätöksenne dataan tuntuman sijaan. Näe kuviot ja optimointimahdollisuudet suoraan.",
          },
          overview: {
            title: "Täysi yleiskuva",
            description:
              "Kaikki organisaatiossa näkevät saman kuvan. Ei enää epäselvyyksiä siitä, missä rajat kulkevat.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Tuo datanne",
            description:
              "Lataa olemassa olevat alueenne, osoitteenne tai koordinaattinne. Atlas tukee shapetiedostoja, CSV:tä ja API-tuontia.",
          },
          second: {
            title: "Luo ja mukauta",
            description:
              "Rakenna alueita postinumeroalueilla rakennuspalikoina, piirrä vapaasti, visualisoi lämpökartoilla ja mittaa etäisyyksiä.",
          },
          third: {
            title: "Jaa ja integroi",
            description:
              "Julkaise karttoja iFramen kautta, vie dataa tai yhdistä järjestelmiinne API:n kautta.",
          },
        },
      },
      pricing: {
        features: {
          binding12: "12 kuukauden sitoutumisaika",
          adminMapCountry: "1 ylläpitäjä, 1 kartta, 1 maa",
          importData: "Tuo omaa dataa kartalle",
          manageAreas: "Luo, näytä ja hallitse alueita",
          apiIntegration: "Integroi järjestelmiinne API:n kautta",
          export2000: "Vie 2 000 postinumeroa/kk",
          exportUnlimited: "Vie rajattomasti postinumeroita",
          routingIncluded: "Routing Small sisältyy",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "1 795 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "2 995 SEK",
          },
          medium3: {
            name: "MEDIUM 3 KK",
            price: "3 595 SEK",
          },
        },
        addons: {
          extraCountry: { name: "Lisämaa", price: "1 000 SEK/kk" },
          extraMap: { name: "Lisäkartta", price: "495 SEK/kk" },
          extraAdmin: { name: "Lisäylläpitäjä", price: "295 SEK/kk" },
          extraViewer: { name: "Lisäkatselija", price: "95 SEK/kk" },
          exportPostal: { name: "Vienti postinumeroita", small: "0,80 SEK/kpl", mediumPlus: "Sisältyy" },
          exportCoords: { name: "Vienti koordinaatteja", small: "1,00 SEK/kpl", mediumPlus: "0,90 SEK/kpl" },
        },
      },
    },
    valid: {
      hero: {
        title: "Valid",
        tagline: "Osoitevalidointi & rikastaminen",
        subtitle:
          "Validoi, korjaa ja rikasta osoitteita reaaliajassa Ruotsissa, Norjassa, Tanskassa ja Suomessa. API:n, lomakkeiden automaattitäydennyksen tai verkkohaun kautta – Valid varmistaa oikeat osoitetiedot joka vaiheessa.",
      },
      overview:
        "Valid on Gepositin palvelu osoitevalidointiin, automaattitäydennykseen ja rikastamiseen täydellä pohjoismaisella kattavuudella. Tarkista, löytyykö osoite Ruotsista, Norjasta, Tanskasta tai Suomesta, anna käyttäjälle älykkäitä ehdotuksia kirjoittaessa ja rikasta jokainen osoite yli 10 maantieteellisellä attribuutilla. Saatavilla REST API:n kautta tai hakupalveluna verkkokäyttöliittymässä.",
      featureGroups: {
        api: "API-palvelut",
        web: "Verkkokäyttöliittymä",
      },
      features: {
        title: "Oikeat osoitetiedot – joka kerta",
        subtitle:
          "Valid nappaa virheet ennen kuin niistä tulee ongelmia. Integroi järjestelmiinne tai käytä hakupalvelua suoraan selaimessa.",
        items: {
          validation: {
            title: "Osoitevalidointi",
            description:
              "Tarkista, löytyykö osoite ja onko se oikein. Saat välittömän palautteen tilanäytöllä ja korjausehdotuksilla.",
          },
          autocomplete: {
            title: "Automaattitäydennys",
            description:
              "Anna käyttäjälle älykkäitä osoite-ehdotuksia reaaliajassa kirjoittaessa. Nopeampi täyttö, vähemmän virheitä, parempi käyttökokemus.",
          },
          enrichment: {
            title: "Rikastaminen",
            description:
              "Täydennä jokainen osoite yli 10 attribuutilla: maakunta, kunta, kaupunginosa, seurakunta, koordinaatit, kiinteistötunnus, DeSO/RegSO ja muuta.",
          },
          search: {
            title: "Hakupalvelu verkkokäyttöliittymässä",
            description:
              "Hae ja vahvista osoitteita suoraan Gepositin verkkokäyttöliittymässä – ilman API-integraatiota. Täydellinen manuaaliseen tarkistukseen.",
          },
          coverage: {
            title: "Pohjoismainen kattavuus",
            description:
              "Täydellinen osoitetietokanta Ruotsille, Norjalle, Tanskalle ja Suomelle. Päivitetään viikoittain virallisista lähteistä.",
          },
        },
      },
      enrichmentData: {
        title: "Rikastusattribuutit",
        subtitle:
          "Jokainen validoitu osoite voidaan rikastaa seuraavilla maantieteellisillä ja hallinnollisilla attribuuteilla.",
        items: {
          county: {
            name: "Maakunta",
            description: "Hallinnollinen maakunta, johon osoite kuuluu",
          },
          municipality: {
            name: "Kunta",
            description: "Kunta, johon osoite on rekisteröity",
          },
          district: {
            name: "Kaupunginosa",
            description: "Maantieteellinen alue kunnan sisällä",
          },
          parish: {
            name: "Seurakunta",
            description: "Kirkkoseurakunta osoitteelle",
          },
          lkfCode: {
            name: "LKF-koodi",
            description:
              "Tilastollinen aluekoodi (Maakunta, Kunta, Seurakunta)",
          },
          municipalityCode: {
            name: "Kuntakoodi",
            description: "Virallinen numeerinen kuntakoodi",
          },
          property: {
            name: "Kiinteistötunnus",
            description:
              "Virallinen kiinteistötunnus Maanmittauslaitokselta",
          },
          coordinates: {
            name: "Koordinaatit",
            description:
              "Leveysaste ja pituusaste (WGS84) osoitteelle",
          },
          deso: {
            name: "DeSO",
            description: "Demografinen tilastoalue (SCB)",
          },
          regso: {
            name: "RegSO",
            description: "Alueellinen tilastoalue (SCB)",
          },
          uuid: {
            name: "UUID",
            description: "Yksilöivä tunniste osoitteelle",
          },
          postalCode: {
            name: "Postinumero",
            description: "Vahvistettu ja ajantasainen postinumero",
          },
          city: {
            name: "Postitoimipaikka",
            description:
              "Virallinen postitoimipaikka postinumerolle",
          },
        },
      },
      useCases: {
        title: "Käyttökohteet",
        items: {
          checkout: {
            title: "Verkkokaupan kassa",
            description:
              "Integroi automaattitäydennys ja validointi kassaan. Asiakas syöttää oikean osoitteen suoraan – vähemmän palautuksia, nopeampi toimitus.",
          },
          booking: {
            title: "Varausportaalit",
            description:
              "Varmista oikeat osoitteet huoltovarauksessa. Teknikko löytää oikeaan paikkaan heti ilman turhia puheluita.",
          },
          systemIntegration: {
            title: "Järjestelmäintegraatio",
            description:
              "Validoi ja rikasta osoitteet tuotaessa CRM-, ERP- tai markkinointijärjestelmiin. Varmista datalaatu alusta alkaen.",
          },
          crmQuality: {
            title: "CRM-laatu",
            description:
              "Aja asiakasrekisterinne Validin kautta tunnistaaksenne ja korjataksenne virheelliset osoitteet. Parempaa dataa, parempia päätöksiä.",
          },
        },
      },
      benefits: {
        title: "Miksi Valid?",
        items: {
          returns: {
            title: "Vähemmän palautuksia",
            description:
              "Oikeat osoitetiedot alusta alkaen tarkoittavat vähemmän palautuvia kirjeitä ja paketteja.",
          },
          experience: {
            title: "Parempi asiakaskokemus",
            description:
              "Nopeammat lomakkeet automaattitäydennyksellä ja välittömällä validoinnilla. Asiakkaanne arvostavat sitä.",
          },
          costs: {
            title: "Alemmat kustannukset",
            description:
              "Jokainen virheellinen osoite maksaa teille rahaa. Valid maksaa itsensä takaisin vähentyneillä virhekustannuksilla.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Integroi tai hae",
            description:
              "Yhdistä Valid järjestelmäänne REST API:n kautta tai käytä hakupalvelua suoraan verkkokäyttöliittymässä.",
          },
          second: {
            title: "Validoi ja rikasta",
            description:
              "Osoitteet validoidaan reaaliajassa. Virheelliset osoitteet korjataan ja rikastetaan 10+ attribuutilla automaattisesti.",
          },
          third: {
            title: "Oikeaa dataa – aina",
            description:
              "Jokainen osoite järjestelmässänne on vahvistettu, täydellinen ja yhdistetty ajantasaiseen maantieteelliseen dataan.",
          },
        },
      },
      demo: {
        title: "Kokeile Validia",
        subtitle: "Kokeile palvelua suoraan – valitse maa, kirjoita osoite ja katso, miten Valid validoi, ehdottaa ja rikastaa reaaliajassa.",
        countryLabel: "Valitse maa:",
        countries: {
          se: "Ruotsi",
          no: "Norja",
          dk: "Tanska",
          fi: "Suomi",
        },
        tabs: {
          autocomplete: "Automaattitäydennys",
          validate: "Validoi",
          enrich: "Rikasta",
        },
        autocomplete: {
          description: "Ala kirjoittaa osoitetta ja näe ehdotuksia reaaliajassa. Valitse ehdotus täyttääksesi osoitteen.",
          placeholder: "Ala kirjoittaa osoitetta…",
          selected: "Valittu osoite",
        },
        validate: {
          description: "Syötä osoite ja napsauta Validoi tarkistaaksesi, löytyykö se ja onko se oikein.",
          streetLabel: "Katuosoite",
          streetPlaceholder: "esim. Mannerheimintie 1",
          postcodeLabel: "Postinumero",
          postcodePlaceholder: "esim. 00100",
          localityLabel: "Postitoimipaikka",
          localityPlaceholder: "esim. Helsinki",
          button: "Validoi osoite",
          validMessage: "Osoite on oikein!",
          invalidMessage: "Osoitetta ei voitu vahvistaa",
          suggestions: "Tarkoititko ehkä:",
        },
        enrich: {
          description: "Syötä osoite ja napsauta Rikasta nähdäksesi kaikki maantieteelliset ja hallinnolliset tiedot.",
          button: "Rikasta osoite",
          errorMessage: "Osoitetta ei voitu rikastaa. Tarkista, että se on oikein.",
        },
      },
      pricing: {
        features: {
          nordicValidation: "Osoitteiden validointi koko Pohjolassa",
          autocomplete: "Automaattitäydennys katuosoitteille, postinumeroille ja postitoimipaikoille",
          adminControl: "Maakunnan, kunnan, seurakunnan ja kaupunginosan tarkistus",
        },
        details: {
          validationsIncluded: "Validoinnit/kk",
          autocompleteIncluded: "Automaattitäydennys/kk",
          extraValidation: "Ylimääräinen validointi",
          extraAutocomplete: "Ylimääräinen automaattitäydennys",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "695 SEK",
            validations: "1 000",
            autocomplete: "7 500",
            extraValidation: "0,50 SEK",
            extraAutocomplete: "0,07 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "1 795 SEK",
            validations: "6 000",
            autocomplete: "45 000",
            extraValidation: "0,35 SEK",
            extraAutocomplete: "0,05 SEK",
          },
          large: {
            name: "LARGE",
            price: "3 995 SEK",
            validations: "20 000",
            autocomplete: "150 000",
            extraValidation: "0,25 SEK",
            extraAutocomplete: "0,03 SEK",
          },
          xl: {
            name: "XL",
            price: "5 995 SEK",
            validations: "40 000",
            autocomplete: "300 000",
            extraValidation: "0,15 SEK",
            extraAutocomplete: "0,01 SEK",
          },
        },
        addons: {
          geocodePostal: { name: "Geokoodaus postinumero", small: "1,00 SEK/kpl", medium: "0,90 SEK/kpl", large: "0,80 SEK/kpl", xl: "0,70 SEK/kpl" },
          geocodeAddress: { name: "Geokoodaus osoite", small: "Tarjouksen mukaan", medium: "Tarjouksen mukaan", large: "Tarjouksen mukaan", xl: "Tarjouksen mukaan" },
          uuid: { name: "UUID", small: "0,10 SEK/kpl", medium: "0,08 SEK/kpl", large: "0,06 SEK/kpl", xl: "0,04 SEK/kpl" },
          property: { name: "Kiinteistötunnus", small: "0,50 SEK/kpl", medium: "0,40 SEK/kpl", large: "0,30 SEK/kpl", xl: "0,20 SEK/kpl" },
          desoRegso: { name: "DeSO/RegSO", small: "0,60 SEK/kpl", medium: "0,50 SEK/kpl", large: "0,40 SEK/kpl", xl: "0,30 SEK/kpl" },
        },
      },
    },
    adresstwatt: {
      hero: {
        title: "Osoitepesu",
        tagline: "Osoiterekisterien ylläpito",
        subtitle:
          "Lähetä osoiterekisterinne – saatte takaisin pestyn, korjatun ja rikastetun version. Tunnistamme virheelliset osoitteet, duplikaatit ja vanhentuneet tiedot Ruotsissa, Norjassa, Tanskassa ja Suomessa.",
      },
      overview:
        "Osoitepesu on Gepositin palvelu olemassa olevien osoiterekisterien laadunvarmistukseen koko Pohjolassa. Lähetätte rekisterinne haluamassanne muodossa, ja me analysoimme jokaisen osoitteen ajantasaista tietokantaamme vasten Ruotsissa, Norjassa, Tanskassa ja Suomessa. Virheelliset osoitteet korjataan, duplikaatit tunnistetaan ja jokainen osoite rikastetaan samoilla attribuuteilla, joita Valid toimittaa.",
      featureGroups: {
        analyze: "Analysoi & tunnista",
        correctAndEnrich: "Korjaa & rikasta",
      },
      features: {
        title: "Puhdasta osoitedataa – koko rekisterissä",
        subtitle:
          "Osoitepesu huolehtii olemassa olevasta osoitedatastanne ja varmistaa korkean laadun.",
        items: {
          analyze: {
            title: "Rekisterianalyysi",
            description:
              "Analysoimme olemassa olevan rekisterinne ja tunnistamme virheelliset, puutteelliset ja vanhentuneet osoitteet. Saatte täydellisen laataraportin.",
          },
          correct: {
            title: "Korjaus virallista dataa vasten",
            description:
              "Virheelliset osoitteet korjataan automaattisesti ajantasaista tietokantaamme vasten, jossa on viralliset osoitteet pohjoismaisista lähteistä.",
          },
          duplicates: {
            title: "Duplikaattien poisto",
            description:
              "Tunnista ja käsittele duplikaatit rekistereissänne. Yhdistä, merkitse tai poista saadaksenne puhtaan asiakasrekisterin.",
          },
          enrich: {
            title: "Rikastaminen attribuuteilla",
            description:
              "Jokainen osoite rikastetaan samoilla attribuuteilla kuin Valid: maakunta, kunta, koordinaatit, kiinteistötunnus, DeSO/RegSO ja muuta.",
          },
          report: {
            title: "Laataraportti",
            description:
              "Saatte yksityiskohtaisen raportin tilastoilla korjatuista, poistetuista ja rikastetuista osoitteista. Näette tarkalleen, mitä on tehty.",
          },
          flexible: {
            title: "Joustavat muodot",
            description:
              "Lähettäkää osoitteenne CSV-, Excel- tai API-muodossa. Saatte takaisin pestyn version samassa muodossa – valmiina tuontiin.",
          },
        },
      },
      useCases: {
        title: "Käyttökohteet",
        items: {
          registerCare: {
            title: "Rekisterin ylläpito",
            description:
              "Säännöllinen asiakasrekisterin pesu datalaadun ylläpitämiseksi. Ajettavissa neljännesvuosittain tai ennen tärkeitä kampanjoita.",
          },
          campaigns: {
            title: "Kampanjapostitukset",
            description:
              "Peskää rekisteri ennen fyysisiä postituksia. Välttäkää virheellisten osoitteiden aiheuttamat kustannukset.",
          },
          gdpr: {
            title: "GDPR & datalaatu",
            description:
              "Tunnistakaa ja puhdistakaa vanhentuneet osoitteet osana GDPR-työtänne. Säilyttäkää vain tarvitsemanne data.",
          },
        },
      },
      benefits: {
        title: "Miksi Osoitepesu?",
        items: {
          quality: {
            title: "Korkeampi datalaatu",
            description:
              "Puhdas osoiterekisteri on kaiken logistiikan, markkinoinnin ja asiakasviestinnän perusta.",
          },
          savings: {
            title: "Suorat säästöt",
            description:
              "Jokainen korjattu osoite vähentää palautusten, virhepostitusten ja manuaalisen käsittelyn kustannuksia.",
          },
          compliance: {
            title: "Parempaa asiakasdataa",
            description:
              "Oikeat osoitteet parantavat CRM-dataanne ja antavat paremman pohjan liiketoimintapäätöksille.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Lähettäkää rekisterinne",
            description:
              "Ladatkaa osoiterekisterinne CSV-, Excel- tai API-muodossa. Tuemme kaikkia yleisiä muotoja.",
          },
          second: {
            title: "Analysoimme ja pesemme",
            description:
              "Jokainen osoite tarkistetaan, korjataan virallista dataa vasten, rikastetaan attribuuteilla ja duplikaatit poistetaan.",
          },
          third: {
            title: "Saatte takaisin puhtaan rekisterin",
            description:
              "Saatte rekisterinne takaisin – korjattuna, rikastettuna ja yksityiskohtaisen laataraportin kera.",
          },
        },
      },
    },
    pricing: {
      tagline: "PAKETIT JA HINNAT",
      title: "Valitse sopiva paketti",
      subtitle: "Kaikki paketit sisältävät tuen ja pääsyn dokumentaatioomme. Tarvitsetteko suurempia volyymeja? Ottakaa yhteyttä räätälöityä ratkaisua varten.",
      recommended: "Suositeltu",
      cta: "Aloita",
      ctaHighlighted: "Aloita",
      showAddons: "Näytä lisävalinnat ja muuttuvat hinnat",
      hideAddons: "Piilota lisävalinnat",
      addonColumn: "Lisävalinta",
      perMonth: "/ kk",
      shortBinding: "3 kk sitoutumisaika",
    },
  },
  solutionPages: {
    backToSolutions: "Kaikki ratkaisut",
    ctaButton: "Varaa demo",
    ctaSecondary: "Katso palvelumme",
    readMore: "Lue lisää",
    overview: {
      tagline: "RATKAISUT",
      title: "Ratkaisut toimialallesi",
      subtitle: "Olipa kyse kuljetuksesta, huollosta tai verkkokaupasta – Geposit antaa sinulle työkalut maantieteesi ja osoitetietojesi optimointiin.",
      segments: {
        transport: {
          title: "Kuljetus & Logistiikka",
          description: "Optimoi toimitusalueet, vähennä palautuksia ja varmista, että jokainen toimitus tavoittaa oikean osoitteen. Määritä omat vyöhykkeet ja saa täysi hallinta kuljetusmaantieteeseesi.",
        },
        service: {
          title: "Huolto & Asennus",
          description: "Suunnittele huoltoalueet ilman päällekkäisyyksiä, jaa resursseja tehokkaasti ja anna asiakkaillenne tarkat käyntiajat maantieteellisen datan perusteella.",
        },
        ecommerce: {
          title: "Verkkokauppa & Omni",
          description: "Validoi asiakasosoitteet reaaliajassa, määritä toimitusvyöhykkeet ja optimoi viimeisen mailin logistiikkanne tyytyväisempien asiakkaiden ja vähempien palautusten puolesta.",
        },
      },
      cta: {
        title: "Epävarma, mikä ratkaisu sopii?",
        subtitle: "Ota yhteyttä, niin autamme sinua löytämään oikean ratkaisun liiketoimintaasi.",
      },
    },
    transport: {
      hero: {
        tagline: "Kuljetus & Logistiikka",
        title: "Tehokkaampia toimituksia maantieteellisellä hallinnalla",
        subtitle: "Määritä toimitusalueet postinumerotarkkuudella, varmista oikeat osoitetiedot ja vähennä palautuksia – niin että jokainen toimitus tavoittaa oikean vastaanottajan oikeaan aikaan.",
      },
      challenges: {
        title: "Kuljetusalan haasteet",
        subtitle: "Kuljetusyritykset kamppailevat päivittäin maantieteellisten ja osoitteisiin liittyvien ongelmien kanssa, jotka maksavat aikaa ja rahaa.",
        items: {
          zones: {
            title: "Epäselvät toimitusvyöhykkeet",
            description: "Ilman selkeästi määriteltyjä toimitusalueita paketit päätyvät väärään paikkaan, vyöhykkeet menevät päällekkäin ja kuljettaja menettää aikaa rajojen selvittelyyn.",
          },
          routes: {
            title: "Epäselvät rajat",
            description: "Ilman datavetoista vyöhykesuunnittelua vastuualueet perustuvat tuntumaan. Se johtaa päällekkäisiin vyöhykkeisiin ja kattavuusaukkoihin.",
          },
          returns: {
            title: "Korkeat palautuskustannukset",
            description: "Virheelliset tai puutteelliset osoitteet johtavat epäonnistuneisiin toimituksiin. Jokainen palautus maksaa rahaa ja heikentää asiakaskokemusta.",
          },
        },
      },
      solutions: {
        title: "Näin Geposit auttaa kuljetusyrityksiä",
        subtitle: "Oikeilla työkaluilla voitte ottaa hallinnan toimitusmaantieteestänne ja vähentää kalliita virheitä.",
        items: {
          areas: {
            title: "Määritä toimitusalueet Atlasissa",
            description: "Luo ja visualisoi omat toimitusvyöhykkeenne Atlasissa postinumeroalueilla rakennuspalikoina. Ei enää epäselviä rajoja – kaikki näkevät saman kuvan.",
          },
          data: {
            title: "Validoi osoitteet Validilla",
            description: "Validilla jokainen osoite validoidaan ennen toimitusta. Virheelliset osoitteet havaitaan suoraan syöttövaiheessa, ja vältätte kalliit palautukset.",
          },
          optimize: {
            title: "Pidä rekisteri puhtaana Osoitepesulla",
            description: "Peskää asiakasrekisterinne säännöllisesti Osoitepesulla. Analysoikaa toimitusalueet ja varmistakaa, että vyöhykejako vastaa todellisuutta.",
          },
        },
      },
      products: {
        title: "Palvelut kuljetukseen",
        subtitle: "Kolme työkalua, jotka yhdessä antavat täyden hallinnan toimitusmaantieteeseen ja osoitelaatuun.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Luo, visualisoi ja hallitse toimitusvyöhykkeitä postinumeroalueilla rakennuspalikoina. Määritä alueet kuljettajan, terminaalin tai alueen mukaan.",
          },
          valid: {
            name: "Valid",
            description: "Validoi toimitusosoitteet reaaliajassa. Nappaa virheelliset osoitteet ennen kuin paketti lähtee terminaalista ja vältä kalliit palautukset.",
          },
          adresstwatt: {
            name: "Osoitepesu",
            description: "Pese asiakasrekisterinne säännöllisesti pitääksenne osoitetiedot oikeina ja ajantasaisina. Vähentäkää virhekustannuksia ja lisätkää toimitustarkuutta.",
          },
        },
      },
      cta: {
        title: "Valmis tehostamaan toimituksianne?",
        subtitle: "Varaa demo ja katso, miten Geposit voi auttaa kuljetusyritystänne vähentämään palautuksia ja optimoimaan toimitusalueita.",
      },
    },
    service: {
      hero: {
        tagline: "Huolto & Asennus",
        title: "Älykkäämpää huoltoalueiden suunnittelua",
        subtitle: "Jaa resursseja maantieteellisesti, poista päällekkäiset vyöhykkeet ja anna asiakkaillenne tarkat käyntiajat – Atlasiin, Validiin ja Osoitepesuun perustuen.",
      },
      challenges: {
        title: "Huoltoalan haasteet",
        subtitle: "Huoltoyritykset ja asennusliikkeet kohtaavat päivittäin maantieteellisiä haasteita, jotka vaikuttavat tehokkuuteen ja asiakastyytyväisyyteen.",
        items: {
          overlap: {
            title: "Päällekkäiset vyöhykkeet",
            description: "Ilman selkeitä rajoja huoltoalueiden välillä riskinä on lähettää useita teknikoita samalle alueelle, kun toiset alueet jäävät alimitoitetuiksi.",
          },
          resources: {
            title: "Epätasainen resurssijako",
            description: "Joillakin teknikoilla on liian laajat alueet, toisilla liian pienet. Ilman maantieteellistä analyysia jako perustuu tuntumaan.",
          },
          scheduling: {
            title: "Epätarkka aikataulutus",
            description: "Ilman oikeita osoitteita ja etäisyyslaskentoja aikaikkunat muuttuvat epäluotettaviksi, mikä johtaa tyytymättömiin asiakkaisiin.",
          },
        },
      },
      solutions: {
        title: "Näin Geposit auttaa huoltoyrityksiä",
        subtitle: "Gepositin työkaluilla voitte suunnitella, visualisoida ja optimoida huoltoalueenne datan perusteella.",
        items: {
          zones: {
            title: "Selkeät huoltoalueet Atlasissa",
            description: "Määritä tarkat huoltoalueet Atlasissa postinumeroalueilla – ei päällekkäisyyksiä, ei aukkoja. Jokainen teknikko tietää tarkalleen vastuualueensa.",
          },
          address: {
            title: "Löydä oikein Validilla",
            description: "Validilla jokainen asiakasosoite varmistetaan varauksessa. Teknikko löytää oikeaan paikkaan suoraan, ja vältätte kalliit turhat käynnit.",
          },
          balance: {
            title: "Puhdasta dataa Osoitepesulla",
            description: "Peskää asiakasrekisterinne Osoitepesulla ja analysoikaa huoltoalueenne tiedoilla kuten asiakasmäärät, etäisyydet ja matka-ajat.",
          },
        },
      },
      products: {
        title: "Palvelut huoltoon",
        subtitle: "Työkalut, jotka antavat huoltotiimillenne oikeat lähtökohdat alusta alkaen.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Luo ja hallitse huoltoalueita visuaalisesti postinumeroilla pohjana. Jaa teknikot vyöhykkeittäin ja katso koko huoltomaantieteenne yhdellä kartalla.",
          },
          valid: {
            name: "Valid",
            description: "Validoi asiakasosoitteet varauksessa. Vältä turhia käyntejä varmistamalla, että jokainen huolto-osoite on oikein.",
          },
          adresstwatt: {
            name: "Osoitepesu",
            description: "Puhdista asiakasrekisterinne virheellisistä osoitteista. Varmistakaa, että huoltoalustanne perustuu oikeaan ja ajantasaiseen dataan.",
          },
        },
      },
      cta: {
        title: "Valmis optimoimaan huoltoalueenne?",
        subtitle: "Varaa demo ja katso, miten Geposit voi auttaa huoltoyritystänne suunnittelemaan älykkäämmin ja toimittamaan paremmin.",
      },
    },
    ecommerce: {
      hero: {
        tagline: "Verkkokauppa & Omni",
        title: "Täydellinen toimitus joka kanavassa",
        subtitle: "Validoi asiakasosoitteet suoraan kassalla, määritä toimitusvyöhykkeet ja varmista, että jokainen tilaus tavoittaa oikean vastaanottajan – kanavasta riippumatta. Validilla, Atlasilla ja Osoitepesulla.",
      },
      challenges: {
        title: "Verkkokaupan haasteet",
        subtitle: "Verkkokauppiaat ja omnikanavayritykset kamppailevat osoitelaadun ja toimitustarkuuden kanssa yhä vaativammilla markkinoilla.",
        items: {
          delivery: {
            title: "Epäselvät toimitusvyöhykkeet",
            description: "Ilman määriteltyjä toimitusalueita on vaikeaa tarjota eriytettyjä toimitusvaihtoehtoja ja vyöhykekohtaista hinnoittelua.",
          },
          returns: {
            title: "Palautukset osoitevirheiden takia",
            description: "Asiakkaat syöttävät virheellisiä osoitteita, ja ilman validointia paketti lähetetään silti. Tulos: palautuksia, kustannuksia ja tyytymättömiä asiakkaita.",
          },
          expansion: {
            title: "Pohjoismainen laajentuminen",
            description: "Laajentuminen uusille pohjoismaisille markkinoille vaatii oikeat osoitetiedot jokaiselle maalle. Virheellinen data hidastaa kasvua ja lisää kustannuksia.",
          },
        },
      },
      solutions: {
        title: "Näin Geposit auttaa verkkokauppiaita",
        subtitle: "Oikeilla tiedoilla ja työkaluilla voitte vähentää palautuksia, parantaa asiakaskokemusta ja laajentua turvallisemmin.",
        items: {
          zones: {
            title: "Älykkäät toimitusvyöhykkeet Atlasissa",
            description: "Määritä toimitusalueet Atlasissa postinumeroalueilla ja yhdistä ne toimitusvaihtoehtoinne. Tarjoa oikea toimitusvalinta asiakkaan osoitteen perusteella – automaattisesti.",
          },
          validation: {
            title: "Osoitevalidointi Validilla kassassa",
            description: "Validilla asiakkaan osoite validoidaan suoraan syöttövaiheessa. Automaattitäydennys antaa älykkäitä ehdotuksia ja virheelliset osoitteet korjataan ennen tilauksen luomista.",
          },
          quality: {
            title: "Puhdasta asiakasdataa Osoitepesulla",
            description: "Peskää asiakasrekisterinne säännöllisesti Osoitepesulla. Pitäkää CRM-datanne puhtaana ja ajantasaisena parempaa markkinointia ja toimitustarkuutta varten.",
          },
        },
      },
      products: {
        title: "Palvelut verkkokauppaan",
        subtitle: "Kaikki mitä tarvitsette oikeita osoitetietoja ja optimoitua toimituslogistiikkaa varten.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Määritä toimitusvyöhykkeet alueen tai toimitustavan mukaan postinumeroalueilla pohjana. Katso toimitusalueenne kartalla ja optimoikaa toimitusrakennettanne.",
          },
          valid: {
            name: "Valid",
            description: "Integroi osoitevalidointi suoraan kassaanne. Anna asiakkaalle oikeat osoite-ehdotukset ja vältä toimitusongelmia alusta alkaen.",
          },
          adresstwatt: {
            name: "Osoitepesu",
            description: "Laadunvarmista asiakasrekisterinne ja pidä datanne virheettömänä. Täydellinen säännölliseen puhdistukseen ennen kampanjoita ja postituksia.",
          },
        },
      },
      cta: {
        title: "Valmis parantamaan toimitustarkuuttanne?",
        subtitle: "Varaa demo ja katso, miten Geposit voi auttaa verkkokauppaanne vähentämään palautuksia ja validoimaan osoitteita reaaliajassa.",
      },
    },
  },
  socialProof: {
    logoTitle: "Yli 900 yritystä luottaa Gepositiin",
    title: "Mitä asiakkaamme sanovat",
    subtitle: "Autamme johtavia pohjoismaisia yrityksiä ottamaan hallinnan maantieteestään.",
    testimonials: {
      first: {
        quote:
          "Nyt meillä on paljon vähemmän alueita, joissa meiltä puuttuu kattavuus palveluillemme. Aiemmin meillä oli 'sokeita pisteitä' alueilla, joihin olisimme muuten voineet toimittaa. Atlasin yleiskuva on tehnyt vaikutusalueistamme sekä selkeämpiä että yksinkertaisempia.",
        author: "Björn Nilsson",
        company: "Verkkojärjestelmävastaava, Elon",
      },
      second: {
        quote:
          "Kätevä palvelu toimitusalueiden määrittelyyn ja niiden jakamiseen eri vyöhykkeisiin. Helppoa viedä postinumerolistoja kullekin alueelle.",
        author: "Julian Lee",
        company: "Perustaja, Airmee",
      },
    },
  },
  customerCases: {
    hero: {
      title: "Asiakastapaukset",
      subtitle: "Katso, miten pohjoismaiset yritykset käyttävät Gepositia optimoidakseen maantiedettään, vähentääkseen palautuksia ja tehostaakseen logistiikkaansa.",
    },
    logos: {
      title: "Gepositia käyttävät yritykset",
      subtitle: "Yli 900 yritystä, organisaatiota ja viranomaista luottaa datahamme.",
    },
    featured: {
      tagline: "Asiakastapaus",
      title: "Nopeampia toimituksia markkinajohtajalle",
      company: "Best Transport",
      companyDesc: "Markkinajohtava toimija nopeissa toimituksissa Pohjolassa.",
      description: "Best Transport on markkinajohtava toimija nopeissa toimituksissa Pohjolassa. Vastatakseen asiakkaidensa vaatimuksiin nopeista ja tarkoista toimituksista vaaditaan hyvin suunniteltuja ja selkeitä maantieteellisiä vyöhykkeitä.",
      result: "Atlas-karttapalvelun avulla yhtenäisenä suunnittelutyökaluna Best Transport pystyi luomaan sekä paremman yleiskuvan että optimaaliset jakeluvyöhykkeet. Tuloksena oli korkeampi täyttöaste ajoneuvoissa ja siten parantunut kannattavuus, vähentyneet hiilidioksidipäästöt – ja tyytyväisemmät asiakkaat!",
      stats: {
        efficiency: {
          value: "Täyttöaste",
          label: "Korkeampi täyttöaste ajoneuvoissa",
        },
        emissions: {
          value: "CO₂",
          label: "Vähentyneet hiilidioksidipäästöt",
        },
        satisfaction: {
          value: "Tyytyväisyys",
          label: "Tyytyväisemmät loppuasiakkaat",
        },
      },
      bullets: {
        challenge: "Monimutkainen vyöhykerakenne monilla päällekkäisillä palveluilla",
        solution: "Atlas yhtenäisenä suunnittelutyökaluna vyöhykejakoon",
        outcome: "Optimaaliset jakeluvyöhykkeet korkeammalla täyttöasteella",
      },
    },
    testimonials: {
      title: "Mitä asiakkaamme sanovat",
      elon: {
        quote: "Nyt meillä on paljon vähemmän alueita, joissa meiltä puuttuu kattavuus palveluillemme. Aiemmin meillä oli 'sokeita pisteitä' alueilla, joihin olisimme muuten voineet toimittaa. Atlasin yleiskuva on tehnyt vaikutusalueistamme sekä selkeämpiä että yksinkertaisempia.",
        author: "Björn Nilsson",
        role: "Verkkojärjestelmävastaava",
        company: "Elon",
      },
      airmee: {
        quote: "Kätevä palvelu toimitusalueiden määrittelyyn ja niiden jakamiseen eri vyöhykkeisiin. Helppoa viedä postinumerolistoja kullekin alueelle.",
        author: "Julian Lee",
        role: "Perustaja",
        company: "Airmee",
      },
    },
    cta: {
      title: "Haluatko olla seuraava menestystarina?",
      subtitle: "Varaa demo ja katso, miten Geposit voi tehostaa juuri teidän liiketoimintaanne.",
      button: "Varaa demo",
    },
  },
  cta: {
    title: "Valmis ottamaan hallinnan?",
    subtitle:
      "Keskustele kanssamme, miten Geposit voi auttaa liiketoimintaanne optimoimaan maantiedettä ja osoitelaatua.",
    form: {
      company: "Yrityksen nimi",
      name: "Nimi",
      email: "Sähköposti",
      role: "Rooli",
      interest: "Mistä haluaisit tietää lisää?",
      interestOptions: {
        atlas: "Atlas – Maantieteelliset alueet",
        valid: "Valid – Osoitevalidointi",
        adresstwatt: "Osoitepesu – Osoitteiden puhdistus",
        general: "Yleistä tietoa",
      },
      message: "Viesti (valinnainen)",
      submit: "Lähetä tiedustelu",
      success: "Kiitos tiedustelustanne! Otamme teihin yhteyttä piakkoin.",
    },
  },
  footer: {
    description:
      "Geposit on Pohjolan johtava alusta osoite- ja geodatalle. Oikeilla ja ajantasaisilla perustiedoilla tarjoamme verkkopalveluja, integraatioita API:n kautta ja dataa tiedostona.",
    quickLinks: "Pikalinkit",
    products: "Palvelut",
    contact: "Yhteystiedot",
    address: "Biblioteksgatan 29, 114 35 Tukholma",
    email: "info@geposit.se",
    phone: "+46 8 410 239 70",
    partOf: "Osa Movement Softwarea",
    progritsDesc:
      "Vuodesta 2015 Geposit on ollut osa Movement Softwarea (aiemmin Progrits) – kansainvälistä ohjelmistokonsenia, joka keskittyy verkkokauppaan, logistiikkaan ja ajoneuvoihin.",
    sister: "Sisaryhtiö",
    postnummerservice: "Postnummerservice",
    postnummerserviceDesc:
      "Postnummerservice on vuodesta 2005 auttanut yksityishenkilöitä, yrityksiä ja organisaatioita Pohjolassa oikeilla ja ajantasaisilla osoite-, postinumero- ja geodatoilla.",
    copyright: "© 2026 Geposit AB. Kaikki oikeudet pidätetään.",
    privacy: "Tietosuojaseloste",
    terms: "Ehdot",
  },
  about: {
    hero: {
      title: "Tietoa Gepositista",
      subtitle: "Ruotsalaisesta jälleenmyyjästä pohjoismaiseksi SaaS-yritykseksi geodatan parissa",
    },
    story: {
      title: "Tarinamme",
      p1: "Geposit on pohjoismainen digitaalisten palveluiden tarjoaja osoite- ja geodatan alalla. Matkamme alkoi vuonna 2005 nimellä Postnummerservice, jolloin toimitimme päivitettyjä osoite- ja postinumerotietoja asiakkaillemme.",
      p2: "Vuonna 2010 lanseerasimme automaattisen osoitteen tarkistuksen ja seuraavana vuonna tuli ensimmäinen digitaalinen karttapalvelumme vyöhykejakoon. Nykyään tarjoamme digitaalisia palveluja, jotka yksinkertaistavat, laadunvarmistavat ja automatisoivat osoitteiden ja maantieteellisten tietojen käsittelyä.",
      p3: "Nykyään palveluitamme käyttävät yritykset kaikkialla Pohjolassa. Tarvitsitpa sitten osoite- ja datapuhdistusta, älykästä vyöhykejakoa tai geodatapalveluja API:n kautta, ratkaisumme perustuvat aina oikeisiin ja ajantasaisiin perustietoihin.",
    },
    data: {
      title: "Pohjolan luotettavimmat osoitetiedot",
      description: "Tiesitkö, että osoitteet ja postinumerot muuttuvat joka viikko? Uusia asuinalueita syntyy, teitä rakennetaan uudelleen ja kaupungit muuttuvat. Joka vuosi päivitetään noin 250 000 osoitetta ja postinumeroa Ruotsissa, mikä vaikuttaa jopa puoleen miljoonaan ihmiseen.",
      description2: "Gepositissa keräämme jatkuvasti dataa luotettavista ja virallisista lähteistä kuten kansallisilta postioperaattoreilta, maanmittauslaitoksilta ja viranomaisilta. Datatoimitusten korkean laadun ansiosta olemme nykyään arvostettu kumppani yli 900 yritykselle, organisaatiolle ja viranomaiselle.",
      stats: {
        customers: "+5 000",
        customersLabel: "Tyytyväistä asiakasta vuodesta 2005",
        countries: "4",
        countriesLabel: "Pohjoismaata",
        addresses: "250 000",
        addressesLabel: "Osoitemuutosta vuodessa Ruotsissa",
      },
    },
    values: {
      title: "Meitä ohjaa",
      innovation: {
        title: "Tekninen innovaatio",
        description: "Kehitämme jatkuvasti uusia ratkaisuja asiakasen hyöty keskiössä. Teknologiamme perustuu luotettaviin ja ajantasaisiin perustietoihin.",
      },
      trust: {
        title: "Luottamus ja yhteistyö",
        description: "Uskomme, että luottamus, osallisuus ja kannustava ilmapiiri johtavat sitoutumiseen ja yhteiseen menestykseen.",
      },
      quality: {
        title: "Laatu joka yksityiskohdassa",
        description: "Datamme päivitetään viikoittain virallisista lähteistä. Emme koskaan tingi laadusta.",
      },
    },
    progrits: {
      title: "Osa Movement Softwarea",
      description: "Vuodesta 2015 Geposit on ollut osa Movement Softwarea (aiemmin Progrits) – kansainvälistä yritysryhmää erikoisohjelmistoissa ja tietopalveluissa yritysten välillä.",
      description2: "Movement Softwaressa teemme yhteistyötä muiden B2B-yritysten kanssa luodaksemme vahvempia asiakastarjouksia ja parempia työtapoja.",
      tagline: "WE MOVE YOUR WORLD",
      link: "Vieraile movementsoftware.com",
    },
    postnummerservice: {
      title: "Sisaryhtiö: Postnummerservice",
      description: "Postnummerservice on vuodesta 2005 auttanut yksityishenkilöitä, yrityksiä ja organisaatioita Pohjolassa tarjoamalla oikeita ja ajantasaisia osoite-, postinumero- ja geodatoja.",
      description2: "Postnummerservice kerää ja käsittelee dataa luotettavista lähteistä kuten kansallisilta postioperaattoreilta, maanmittauslaitoksilta ja virallisilta viranomaisilta. Data päivitetään viikoittain korkean laadun ja tarkkuuden takaamiseksi.",
      link: "Vieraile postnummerservice.se",
    },
    ecoroute: {
      title: "Sisaryhtiö: Ecoroute",
      description: "Ecoroute kehittää älykästä reittisuunnittelua ja optimointia Pohjoismaiden kuljetus- ja logistiikkayrityksille. Tehokkuuteen ja kestävyyteen keskittyen he auttavat asiakkaitaan vähentämään ajokilometrejä, alentamaan kustannuksia ja pienentämään ilmastovaikutuksia.",
      description2: "Movement Softwaren Transportation & Logistics -painopistealueella yhdistämme Ecorouten reittioptimoinnin Gepositin osoite- ja geodatapalveluihin kokonaisvaltaisten toimitusketjuratkaisujen tarjoamiseksi.",
      link: "Vieraile ecoroute.com",
    },
    careers: {
      title: "Liity Gepositiin",
      description: "Kasvamme ja etsimme aina uusia osaajia. Meitä ohjaa tekninen innovaatio vaatimuksella, että asiakkaidemme saama arvo on aina keskiössä.",
      cta: "Ota yhteyttä",
    },
  },
  information: {
    title: "Tiedot",
    subtitle: "Uutisia, asiakirjoja ja tärkeää tietoa Gepositilta.",
    news: {
      title: "Uutiset",
      subtitle: "Viimeisimmät Gepositilta – päivitykset, parannukset ja uutiset.",
      empty: "Ei vielä julkaistuja uutisia.",
    },
    documents: {
      title: "Asiakirjat ja ehdot",
      subtitle: "Täältä löydätte yleiset ehtomme, käytäntömme ja muut asiakirjat.",
    },
    quickNav: {
      news: "Uutiset",
      documents: "Asiakirjat & ehdot",
    },
    readMore: "Lue lisää",
    categories: {
      villkor: "Ehdot",
      policy: "Käytäntö",
      ovrigt: "Muut",
    },
  },
  cookieBanner: {
    title: "Käytämme evästeitä",
    description: "Käytämme evästeitä parantaaksemme kokemustasi verkkosivuillamme, analysoidaksemme liikennettä ja mukauttaaksemme sisältöä.",
    readMore: "Lue evästekäytäntömme",
    accept: "Hyväksy",
    reject: "Hylkää",
  },
  cookiePolicy: {
    title: "Evästekäytäntö",
    lastUpdated: "Päivitetty viimeksi: 18.3.2024",
    intro: "Keräämme tietoja teknologian, kuten evästeiden, avulla (esim. selaimessasi tai laitteellasi). Evästeitä käytetään tunnisteiden ja muiden tietojen tallentamiseen ja vastaanottamiseen tietokoneilla, puhelimilla ja muilla laitteilla. Evästeet voivat esimerkiksi auttaa meitä tunnistamaan sinut seuraavan kerran, kun vierailet verkkosivuillamme, ja mahdollistaa turvallisemman ja luotettavamman palvelun tarjoamisen.",
    purposeTitle: "Käytämme evästeitä seuraaviin tarkoituksiin",
    types: {
      functional: {
        title: "Toiminnalliset evästeet",
        description: "Käytämme toiminnallisia evästeitä sivujemme tiettyjen toimintojen hallintaan, jotta valintasi ja asetuksesi muistetaan, kun palaat verkkosivulle.",
      },
      analytics: {
        title: "Analytiikkaevästeet",
        description: "Käytämme analytiikkaevästeitä mittaamaan, miten palveluitamme kysytään, käytetään ja miten ne toimivat käytössä. Keräämiämme tietoja käytetään palvelumme ylläpitoon ja parantamiseen.",
      },
      thirdParty: {
        title: "Kolmannen osapuolen evästeet",
        description: "Voimme myös sallia yhteistyökumppaneidemme käyttää evästeitä palveluissamme edellä kuvattuihin tarkoituksiin. Voimme myös sallia puolestamme palveluja tarjoavien kolmansien osapuolten käyttää evästeitä edellä kuvattuihin tarkoituksiin.",
      },
    },
    managingTitle: "Evästeiden hallinta",
    managingText: "Useimmat selaimet antavat käyttäjän valita, miten evästeitä käsitellään. Voit asettaa selaimesi kieltäytymään evästeistä tai poistamaan tiettyjä evästeitä. Täältä löydät tietoa evästeiden hallinnasta selaimessasi:",
    blockingWarning: "Jos päätät estää evästeet, osa palvelumme toiminnallisuudesta voi heikentyä tai kadota, koska se edellyttää evästeiden sallimista.",
    changesTitle: "Muutokset tähän käytäntöön",
    changesText: "Geposit voi aika ajoin muuttaa tätä evästekäytäntöä evästeiden käyttö- ja tietojenkäsittelyrutiinien muuttuessa sekä lakisääteisten vaatimusten noudattamiseksi.",
    contactTitle: "Kysymyksiä",
    contactText: "Jos sinulla on kysymyksiä tai huolenaiheita evästeiden käytöstämme, ota meihin yhteyttä.",
  },
  notFound: {
    title: "404",
    message: "Sivua ei löytynyt",
    backHome: "Takaisin etusivulle",
  },
  kontakt: {
    title: "Yhteystiedot",
    hero: {
      title: "Miten voimme auttaa sinua?",
      subtitle: "Varaa ilmainen demo tai ota yhteyttä kysymyksilläsi – autamme sinua löytämään oikean ratkaisun.",
    },
    types: {
      demo: {
        title: "Varaa demo",
        description: "Saat ilmaisen esittelyn palveluistamme, räätälöitynä liiketoimintaasi.",
      },
      contact: {
        title: "Ota yhteyttä",
        description: "Onko sinulla kysymyksiä tuotteistamme, hinnoittelusta tai yhteistyöstä? Ota yhteyttä!",
      },
    },
    contactInfo: {
      title: "Yhteystiedot",
    },
    form: {
      titleDemo: "Varaa ilmainen demo",
      subtitleDemo: "Täytä lomake, niin otamme sinuun yhteyttä sopiaksemme sinulle sopivan ajan.",
      titleContact: "Lähetä viesti",
      subtitleContact: "Kuvaile asiasi ja palaamme asiaan mahdollisimman pian.",
      submitDemo: "Varaa demo",
      submitting: "Lähetetään...",
      success: "Kiitos! Olemme vastaanottaneet viestisi ja palaamme asiaan pian.",
      error: "Jokin meni pieleen. Yritä uudelleen tai ota yhteyttä sähköpostitse.",
      placeholders: {
        company: "Yritys Oy",
        name: "Matti Meikäläinen",
        email: "matti@yritys.fi",
        role: "Logistiikkapäällikkö",
        interest: "Valitse vaihtoehto",
        messageDemo: "Kerro lyhyesti liiketoiminnastanne ja mitä haluaisitte nähdä demossa...",
        messageContact: "Kerro lisää asiastasi...",
      },
    },
  },
  illustrations: {
    keyFactors: "Avaintekijät",
    joinCompanies: "Liity 900+ yritykseen, jotka jo käyttävät Gepositia",
    zoneA: "Vyöhyke A",
    zoneB: "Vyöhyke B",
    zoneC: "Vyöhyke C",
    searchAddress: "Hae osoite…",
    processing: "Käsitellään…",
    completed: "valmiita",
    analysisResult: "Analyysitulos",
    addresses: "osoitetta",
    correctedAddresses: "Korjattuja osoitteita",
    addressFile: "osoitepesu.csv",
  },
  seo: {
    home: "Geposit auttaa yrityksiä luomaan, hallitsemaan ja optimoimaan maantieteellisiä alueita oikealla osoitedatalla Ruotsissa, Norjassa, Tanskassa ja Suomessa.",
    losningar: "Ratkaisut kuljetukseen, huoltopalveluihin ja verkkokauppaan. Optimoi toimitusalueet ja maantieteellinen suunnittelu Pohjoismaissa Gepositin avulla.",
    produkter: "Tutustu Atlakseen, Validiin ja Osoitepesuriin – työkalut maantieteelliseen aluehallintaan ja osoitelaatuun Ruotsissa, Norjassa, Tanskassa ja Suomessa.",
    kundcase: "Katso miten yli 900 yritystä käyttää Gepositia maantieteelliseen hallintaan, parempaan osoitelaatuun ja optimoituihin toimitusvyöhykkeisiin Pohjoismaissa.",
    information: "Uutisia, päivityksiä ja dokumentteja Gepositilta maantieteellisestä datasta, osoitelaadusta ja aluehallinnasta Pohjoismaissa.",
    omGeposit: "Geposit auttaa pohjoismaisia yrityksiä maantieteellisessä hallinnassa ja osoitelaadussa. Osa Movement Software -konsernia.",
    kontakt: "Ota yhteyttä Gepositiin – varaa ilmainen demo tai kysy tuotteistamme ja palveluistamme maantieteelliseen dataan.",
    integritetspolicy: "Gepositin tietosuojakäytäntö – näin käsittelemme henkilötietojasi ja evästeitä.",
  },
  order: {
    pageTitle: "Tilaa",
    pageDescription: "Tilaa Atlas tai Valid Gepositilta.",
    selectProduct: "Valitse tuote",
    selectProductDesc: "Minkä tuotteen haluat tilata?",
    chooseThis: "Valitse tämä",
    configureAtlas: "Määritä Atlas",
    configureAtlasDesc: "Valitse paketti ja määritä tilauksesi.",
    configureValid: "Määritä Valid",
    configureValidDesc: "Valitse paketti ja mahdolliset lisäosat.",
    choosePlan: "Valitse paketti",
    perMonth: "/kk",
    binding12: "12 kk sitoutumisaika",
    binding3: "3 kk sitoutumisaika",
    perMonthShort: "kk",
    adminUsers: "Admin-käyttäjät",
    adminUsersDesc: "1 sisältyy. Lisä: 295 SEK/kk",
    viewerUsers: "Katselukäyttäjät",
    viewerUsersDesc: "0 sisältyy. Lisä: 95 SEK/kk",
    maps: "Kartat",
    mapsDesc: "1 sisältyy. Lisä: 495 SEK/kk",
    countries: { title: "Maat", desc: "Vähintään 1 maa vaaditaan. Ensimmäinen sisältyy, lisä: 1 000 SEK/kk", se: "Ruotsi", no: "Norja", dk: "Tanska", fi: "Suomi" },
    addons: "Lisäosat",
    addonsDesc: "Valitse haluamasi lisäosat peruspakettin lisäksi.",
    userDetails: "Käyttäjätiedot",
    userDetailsDesc: "Anna nimi, sähköposti ja rooli jokaiselle käyttäjälle.",
    adminUser: "Admin-käyttäjä",
    viewerUser: "Katselukäyttäjä",
    userName: "Nimi",
    userNamePlaceholder: "Etunimi Sukunimi",
    userEmail: "Sähköposti",
    userEmailPlaceholder: "nimi@yritys.fi",
    userRole: "Rooli",
    userRolePlaceholder: "esim. Aluevastaava",
    noUsersNeeded: "Käyttäjätietoja ei tarvita tälle tuotteelle.",
    customerDetails: "Asiakas- ja laskutustiedot",
    customerDetailsDesc: "Täytä yhteyshenkilö-, yritys- ja laskutustiedot.",
    contactInfo: "Yhteystiedot",
    firstName: "Etunimi",
    lastName: "Sukunimi",
    phone: "Puhelin",
    email: "Sähköposti",
    companyInfo: "Yritystiedot",
    companyName: "Yrityksen nimi",
    orgNumber: "Y-tunnus",
    orgNumberHint: "10 numeroa, täytä nollilla tarvittaessa",
    address: "Osoite",
    postalCode: "Postinumero",
    city: "Kaupunki",
    country: "Maa",
    billingInfo: "Laskutustiedot",
    copyFromCompany: "Kopioi yritystiedoista",
    billingAddress: "Laskutusosoite",
    reference: "Viitteenne",
    referenceHint: "Esim. yhteyshenkilön nimi",
    poNumber: "Viite/PO-numero",
    poNumberHint: "Esim. sisäinen ostotilausnumero. Jos haluatte vaihtaa PO-numeron tulevaisuudessa, teidän on ilmoitettava meille.",
    invoiceMethod: "Laskutustapa",
    invoiceMethods: { email: "Sähköposti", einvoice: "Verkkolasku", letter: "Kirje" },
    invoiceEmail: "Laskun sähköposti",
    peppolId: "PEPPOL-tunnus",
    peppolIdHint: "Jos ei PEPPOL-tunnusta, valitse toinen vaihtoehto",
    letterNotice: "Lasku lähetetään ilmoitettuun laskutusosoitteeseen. Laskutuslisä veloitetaan.",
    vatNumber: "ALV-tunnus",
    termsPrefix: "Hyväksyn",
    termsLink: "kauppaehdot",
    summary: "Yhteenveto",
    basePlan: "(peruspaketti)",
    total: "Yhteensä",
    validAddonsNote: "Lisäosien hinnat ovat kappalehintoja ja lisätään peruspakettin päälle.",
    step: "Vaihe",
    back: "Takaisin",
    next: "Seuraava",
    submitOrder: "Lähetä tilaus",
    submitting: "Lähetetään...",
    confirmationTitle: "Kiitos tilauksestasi!",
    confirmationDesc: "Olemme vastaanottaneet tilauksesi ja palaamme piakkoin vahvistuksella sähköpostitse.",
    backToHome: "Takaisin etusivulle",
    errorTitle: "Jokin meni pieleen",
    errorDesc: "Tilaustasi ei voitu lähettää. Yritä uudelleen tai ota meihin yhteyttä.",
    share: "Jaa",
    shareOrder: "Jaa tilaus",
    shareCopied: "Linkki kopioitu!",
    shareCopiedDesc: "Konfiguraatiolinkki on kopioitu leikepöydälle.",
    shareFullCopied: "Tilauslinkki kopioitu!",
    shareFullCopiedDesc: "Linkki sisältää kaikki tiedot. Asiakkaan tarvitsee vain hyväksyä ehdot.",
    sharedBanner: "Tämä tilaus on valmisteltu sinulle. Tarkista valinnat ja jatka tilauksen viimeistelyyn.",
    sharedFullBanner: "Tilaus on täytetty puolestasi. Tarkista tiedot, hyväksy ehdot ja lähetä.",
  },
  villkor: {
    hero: {
      tagline: "Asiakirjat ja ehdot",
      title: "Selkeät ehdot turvalliselle yhteistyölle",
      subtitle: "Tästä löydät yhteenvedon ehtojemme tärkeimmistä kohdista sekä mahdollisuuden ladata täydelliset asiakirjat.",
    },
    summary: {
      title: "Yhteenveto ehdoistamme",
      subtitle: "Alla on tiivistetty tärkeimmät kohdat. Täydelliset ehdot ovat ladattavissa sivun alaosasta.",
      disclaimer: "Yllä oleva on yksinkertaistettu yhteenveto eikä korvaa täydellisiä ehtoja. Mahdollisissa ristiriidoissa noudatetaan aina allekirjoitettua sopimusta.",
      items: {
        contract: { title: "Sopimuskausi ja irtisanominen", description: "Sopimus on voimassa valitun sitoutumisajan ja uusiutuu automaattisesti, ellei sitä irtisanota kirjallisesti vähintään 3 kuukautta ennen kauden päättymistä." },
        payment: { title: "Maksu ja hinnat", description: "Laskutus tapahtuu etukäteen. Hintoja tarkistetaan vuosittain ja niistä tiedotetaan etukäteen verkkosivuilla." },
        data: { title: "Tiedot ja yksityisyys", description: "Geposit käsittelee asiakastietoja luottamuksellisesti ja GDPR:n mukaisesti. Asiakastietoja ei koskaan jaeta kolmansille osapuolille ilman suostumusta." },
        responsibility: { title: "Vastuu ja takuut", description: "Geposit vastaa palvelun toimivuudesta määritysten mukaisesti tietyin vastuunrajoituksin. Katso täydelliset ehdot saadaksesi lisätietoja." },
        availability: { title: "Saatavuus ja SLA", description: "Palvelu tarjotaan korkealla saatavuudella. Suunnitelluista katkoista ilmoitetaan etukäteen ja huoltoikkunat ajoittuvat toimistoajan ulkopuolelle." },
        usage: { title: "Käyttö ja rajoitukset", description: "Palvelua saa käyttää sopimuksen puitteissa. Väärinkäyttö, automaattinen tiedonkeruu tai jakelu/jälleenmyynti ilman sopimusta ei ole sallittua." },
      },
    },
    download: {
      title: "Lataa täydelliset ehdot",
      subtitle: "Tästä voit ladata täydelliset sopimusasiakirjamme PDF-muodossa.",
      open: "Avaa",
      empty: "Ei asiakirjoja saatavilla tällä hetkellä.",
    },
    cta: {
      title: "Kysymyksiä ehdoistamme?",
      subtitle: "Ota yhteyttä, niin autamme sinua ymmärtämään, miten ehdot soveltuvat juuri sinun liiketoimintaasi.",
      button: "Ota yhteyttä",
    },
  },
  certifications: {
    title: "Sertifioinnit",
    subtitle: "Työskentelemme järjestelmällisesti laadun, ympäristön ja tietoturvan parissa.",
    iso9001: { title: "ISO 9001", description: "Laadunhallinta" },
    iso14001: { title: "ISO 14001", description: "Ympäristöjohtaminen" },
    iso27001: { title: "ISO 27001", description: "Tietoturva" },
  },
  solutionExtras: {
    transport: {
      heroHighlights: [
        "Määrittele ja visualisoi toimitusalueet postinumerotarkkuudella Atlaksessa",
        "Validoi kaikki osoitteet ennen lähetystä Validilla",
        "Pidä asiakasrekisteri puhtaana Osoitteenpesulla",
      ],
      challengeImpact: "Virheelliset osoitteet ja epäselvät toimitusalueet maksavat kuljetusyrityksille miljoonia vuosittain palautuksina, hukkamatkoina ja viivästyksinä.",
      productBullets: {
        atlas: ["Rakenna toimitusalueet postinumeropolygoneista rakennuspalikoina", "Visualisoi ja analysoi alueita terminaalin, kuljettajan tai alueen mukaan"],
        valid: ["Validoi toimitusosoitteet reaaliajassa ennen kuin paketti lähtee terminaalista", "Nappaa virheelliset ja puutteelliset osoitteet heti syöttövaiheessa"],
        adresstwatt: ["Pese asiakasrekistereitä säännöllisesti tarkkojen osoitetietojen vuoksi", "Tunnista ja korjaa vanhentuneet osoitteet automaattisesti"],
      },
    },
    service: {
      heroHighlights: [
        "Määrittele tarkat palvelualueet postinumerotarkkuudella Atlaksessa",
        "Varmista oikeat asiakasosoitteet varauksen yhteydessä Validilla",
        "Pidä palvelualustasi puhtaana Osoitteenpesulla",
      ],
      challengeImpact: "Päällekkäiset palvelualueet ja virheelliset osoitteet maksavat huoltoyrityksille keskimäärin 15–20 % operatiivisesta kapasiteetista hukkamatkoina ja kaksinkertaisena työnä.",
      productBullets: {
        atlas: ["Rakenna palvelualueet postinumeropolygoneista – ei päällekkäisyyksiä", "Analysoi työkuormaa asiakasmäärän ja maantieteen perusteella"],
        valid: ["Validoi palveluosoitteet suoraan varauksen yhteydessä hukkamatkojen välttämiseksi", "Anna asiakkaille tarkat osoiteehdotukset reaaliajassa autocompleten avulla"],
        adresstwatt: ["Puhdista virheelliset osoitteet asiakasrekisteristä säännöllisesti", "Varmista, että palvelualusta perustuu oikeisiin tietoihin"],
      },
    },
    ecommerce: {
      heroHighlights: [
        "Validoi asiakasosoitteet suoraan kassalla Validilla",
        "Määrittele toimitusalueet postinumerotarkkuudella Atlaksessa",
        "Laajenna turvallisesti Pohjoismaiden markkinoille oikeilla tiedoilla",
      ],
      challengeImpact: "Virheelliset osoitteet verkkokaupassa johtavat siihen, että jopa 5 % kaikista toimituksista epäonnistuu – ja palautukset maksavat 3–5 kertaa enemmän kuin alkuperäinen rahti.",
      productBullets: {
        atlas: ["Rakenna toimitusalueet postinumeropolygoneista alueen, toimitustavan tai hintavyöhykkeen mukaan", "Visualisoi toimitusalueet ja vie postinumerolistat"],
        valid: ["Integroi autocomplete suoraan kassaasi virheettömään osoitteen syöttöön", "Validoi osoitteet reaaliajassa Ruotsissa, Norjassa, Tanskassa ja Suomessa"],
        adresstwatt: ["Varmista asiakasrekisterien laatu ennen kampanjoita ja postituksia", "Tunnista duplikaatit ja vanhentuneet osoitteet massana"],
      },
    },
  },
  pricingDb: {
    nordicValidation: "Osoitteiden validointi koko Pohjolassa",
    autocomplete: "Autocomplete katujen, postinumeroiden ja postitoimipaikkojen osalta",
    adminControl: "Maakunnan, kunnan, seurakunnan ja alueen hallinta",
    bindingTime12: "12 kuukauden sitoutumisaika",
    oneAdminMapCountry: "1 admin, 1 kartta, 1 maa",
    importOwnData: "Tuo omat tiedot kartalle",
    createManageAreas: "Luo, näytä ja hallitse alueita",
    integrateApi: "Integroi järjestelmiisi API:n kautta",
    export2000Postal: "Vie 2 000 postinumeroa/kk",
    exportUnlimitedPostal: "Vie rajaton määrä postinumeroita",
    routingSmallIncluded: "Routing Small sisältyy",
    validationsPerMonth: "Validointeja/kk",
    autocompletePerMonth: "Autocomplete/kk",
    extraValidation: "Ylimenevä validointi",
    extraAutocomplete: "Ylimenevä autocomplete",
    geocodeAddress: "Geokoodaus osoite",
    geocodePostal: "Geokoodaus postinumero",
    propertyDesignation: "Kiinteistötunnus",
    uuid: "UUID",
    desoRegso: "DeSO/RegSO",
    extraCountry: "Lisämaa",
    extraMap: "Lisäkartta",
    extraAdmin: "Lisäadmin",
    extraViewer: "Lisäkatselija",
    exportPostal: "Postinumeroiden vienti",
    exportCoordinates: "Koordinaattien vienti",
    perQuote: "Tarjouksen mukaan",
    included: "Sisältyy",
  },
};

